import { defineMessage } from 'services/localization';

export const messages = {
    referenceField: defineMessage('transaction_number_1'),
    paymentReferenceField: defineMessage('reference'),
    customerField: defineMessage('customer'),
    transactionDateField: defineMessage('date'),
    startDateField: defineMessage('start_date'),
    endDateField: defineMessage('end_date'),
    classField: defineMessage('class'),
    departmentField: defineMessage('department'),
    location: defineMessage('location'),
    memoField: defineMessage('memo'),
    discountItem: defineMessage('discount_item'),
    discountRate: defineMessage('discount_rate'),
    terms: defineMessage('terms'),
    billingSchedule: defineMessage('billing_schedule'),
    positiveBooleanValue: defineMessage('yes'),
};
